import $$ from 'cmn-utils'

const baseUrl = "/api/device/action/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
}